import { RESET_ERROR_BY_NAMESPACE } from './constants';
import { ResetErrorByNamespaceAction } from './types';

export const resetErrorByNamespace = (
    namespace: string | string[]
): ResetErrorByNamespaceAction => {
    return {
        type: RESET_ERROR_BY_NAMESPACE,
        payload: {
            namespace
        }
    };
};
